import { playSound } from '@src/providers/SoundProvider/soundUtils';
import { ModeEnum } from '@talos/kyoko';
import type { AppNotification } from '../AppNotificationsMonitorContainer';

export function processNotificationsForSound(notifications: AppNotification[]) {
  notifications.forEach(notification => {
    if (notification.State === 'New' && notification.SoundMode === ModeEnum.Enabled && notification.SoundSelection) {
      playSound(notification.SoundSelection);
    }
  });
}
